import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locale';
import { crash } from '@/services/crash';

import Button from '@/components/Button';

import style from './ErrorBoundary.sass';

export interface Props {}

export interface State {
  error: boolean;
}

const text = translations.pages.error;

export default class ErrorBoundary extends PureComponent<Props, State> {
  state = {
    error: false
  };

  componentDidCatch(error: Error) {
    this.setState({ error: true });
    return crash.report(error);
  }

  reset = () => this.setState({ error: false });

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (!error) return children;

    return (
      <div className={style.root}>
        <div className={style.content}>
          <div className={style.message}>
            <FormattedMessage id={text.message} />
          </div>

          <Button onClick={this.reset} appearance="red">
            <FormattedMessage id={text.button} />
          </Button>
        </div>
      </div>
    );
  }
}
